// =============================================================================
// Collections — submission defaults for the 3rd-party agency (InstiCollect).
//
// These values seed the InstiCollect submission form whenever a new collections
// case is created from a past-due booking.  They mirror the screenshots in
// /docs and the agency's customer-services portal.  Admins can still edit
// every field per case (e.g. update Min Balance for a special account).
//
// If we ever onboard another agency, expose this as a per-agency profile and
// pick from a dropdown in the UI; for now there's only InstiCollect.
// =============================================================================

export const COLLECTIONS_AGENCY = {
  name: 'InstiCollect',
};

// Defera's account with InstiCollect.
export const INSTICOLLECT_DEFAULTS = {
  client_number:    'Defera LLC - 11596947',
  agreement_number: '1000156160 - InstiCollect',
  debt_category:    'Consumer',
  // Minimum balance the agency will accept.  Below this they refuse to
  // pursue collection — used to filter the Eligible list in the UI.
  min_balance_cents: 5000, // $50.00
  language_spoken:   'English',
  default_country:   'US',
};

// Common days-past-due thresholds the admin can pick from in the filter bar.
// InstiCollect accepts debts at 60+ days past delinquency, so that's our
// default and recommended value. The selected threshold only filters the
// Eligible list — Submitted/closed cases are unaffected.
export const COLLECTIONS_DPD_OPTIONS = [
  { id: 30,  label: '30+ days' },
  { id: 60,  label: '60+ days', recommended: true },
  { id: 90,  label: '90+ days' },
  { id: 120, label: '120+ days' },
  { id: 180, label: '180+ days' },
];

export const DEFAULT_DPD_THRESHOLD = 60;

// Phone / email type vocabularies — match the agency's dropdowns.
export const PHONE_TYPES = ['Mobile', 'Home', 'Work', 'Fax', 'Other'];
export const EMAIL_TYPES = ['Personal', 'Work', 'Other'];
export const ADDRESS_TYPES = ['Home', 'Work', 'Mailing', 'Other'];

// Yes/No fields are stored as booleans in the DB; render as Yes/No labels.
export const YES_NO = (v) => (v === true ? 'Yes' : v === false ? 'No' : '');

// Status pill metadata — keep ids in sync with the CHECK constraint on
// collections_cases.status (migration 057).
export const COLLECTIONS_STATUS = {
  eligible:       { label: 'Eligible',       color: 'amber' },
  queued:         { label: 'Queued',         color: 'sky'   },
  submitted:      { label: 'Submitted',      color: 'blue'  },
  in_collections: { label: 'In Collections', color: 'rose'  },
  partial:        { label: 'Partial Pay',    color: 'amber' },
  recovered:      { label: 'Recovered',      color: 'emerald' },
  written_off:    { label: 'Written Off',    color: 'zinc'  },
  disputed:       { label: 'Disputed',       color: 'orange' },
  closed:         { label: 'Closed',         color: 'zinc'  },
};

export const TERMINAL_STATUSES = ['recovered', 'written_off', 'closed'];
